let currentImgId = '';
let galleryImages = null;

$(document).ready(function() {
  galleryImages = document.getElementsByClassName('gallery-image');
  for (let i = 0; i < galleryImages.length; i++) {

    // console.log(galleryImages[i],"elm",galleryImages[i].id.split('_'),"id")  
    $('#gallery-image-overlay_' + galleryImages[i].id.split('_')[1]).click(showOverlay(galleryImages[i].id));
  }
  
  $('#gallery-slider-close-button').click(function() {
    document.getElementById('full-screen-gallery-view').style.display = 'none';
  });
  
  $('.gallery-slider-next').click(function() {
    if (currentImgId != 'gallery-image_' + galleryImages.length) {
      setGallerySliderCurrentImage(nextImage(currentImgId));
    }
  });
  
  $('.gallery-slider-prev').click(function() {
    if (currentImgId != 'gallery-image_1') {
	    setGallerySliderCurrentImage(prevImage(currentImgId));
    }
  });
});

$(document).keyup(function(e) {
  // escape key should close the overlay if it is open
  if (e.keyCode === 27) {
    if (document.getElementById('full-screen-gallery-view').style.display != 'none' && document.getElementById('full-screen-gallery-view').style.display != '') {
      document.getElementById('full-screen-gallery-view').style.display = 'none';
      let id=$('#current-gallery-image').attr('data-id').split('_')[1]
      
      $('#gallery-image-overlay_'+id).focus();
    }
  }
  
  // right arrow should go to the next image
  if (e.keyCode === 39) {
    if (document.getElementById('full-screen-gallery-view').style.display != 'none' || document.getElementById('full-screen-gallery-view').style.display != '') {
      if (currentImgId != 'gallery-image_' + galleryImages.length) {
        setGallerySliderCurrentImage(nextImage(currentImgId));
      }
    }
  }
  
  // left arrow should go to the previous image
  if (e.keyCode === 37) {
    if (document.getElementById('full-screen-gallery-view').style.display != 'none' || document.getElementById('full-screen-gallery-view').style.display != '') {
      if (currentImgId != 'gallery-image_1') {
        setGallerySliderCurrentImage(prevImage(currentImgId));
      }
    }
  }
});

function showOverlay(i) {

  return function() {
    setGallerySliderCurrentImage(i);
    document.getElementById('full-screen-gallery-view').style.display = 'flex';
    _theme.focusTrap($('#full-screen-gallery-view'), function() {

    })
  };
}

function setGallerySliderCurrentImage(i) {
  document.getElementById('current-gallery-image').src = document.getElementById(i).src;
  document.getElementById('current-gallery-image').alt = document.getElementById(i).alt;
  document.getElementById('current-gallery-image').setAttribute('data-id',i);
  if (document.getElementById(i).dataset.link) {
    $('#current-gallery-image-link').attr({'href': document.getElementById(i).dataset.link,'aria-label': document.getElementById(i).alt });
    $('#current-gallery-image-link').css('cursor', 'pointer');
    $('#current-gallery-image-link').off( "click");
  } else {
    $('#current-gallery-image-link').css('cursor', 'default');
    $('#current-gallery-image-link').click(function(e) {
      e.preventDefault();
    });
  }
  
  if (document.getElementById(i).dataset.caption) {
    $('#gallery-slider-image-caption').html('<h2>'+document.getElementById(i).dataset.caption+'</h2>');
  } 
  currentImgId = i;
}

/*

Input: "gallery-img_10"
Output: "gallery-img_11"

*/
function nextImage(i) {
  let splitId = i.split('_');
  let nextNum = Number(splitId[1]) + 1;
  return `${splitId[0]}_${nextNum}`;
}

/*

Input: "gallery-img_10"
Output: "gallery-img_9"

*/

function prevImage(i) {
  let splitId = i.split('_');
  let nextNum = Number(splitId[1]) - 1;
  return `${splitId[0]}_${nextNum}`;
}